<template>
  <router-link
    class="service-card"
    :to="service.route"
    :aria-label="`link to ${service.name}`"
    :event="'click'"
    :target="service.route === 'learn-more' ? '_blank' : ''"
  >
    <h2>{{ $t(service.name) }}</h2>
    <img
      :src="require(`@/assets/images/${service.icon}`)"
      :alt="`${$t(service.name)}-image`"
    />

    <p class="small service-card-description">{{ $t(service.description) }}</p>

    <div class="service-card-footer" v-if="service.price">
      <p class="small">
        {{ $t(service.priceDescription, { recipients: service.recipients }) }}
      </p>
      <div class="service-card-footer-text">
        <p class="small">{{ $t('W2P_FROM') }}</p>
        <h2 v-if="service.id === '8000'">
          {{ $t('W2P_SERVICE_CARD_DISTRIUTION_ODR_PRICE') }}
        </h2>
        <h2 v-else>{{ service.price.totalWithVAT | formatPrice }}</h2>
        <p class="small">{{ service.units }}</p>
      </div>
    </div>

    <div class="service-card-footer" v-if="service.route === 'utdelningsdag'">
      <p class="small">
        {{ $t('W2P_SERVICE_CARD_SEND_OUT_ARRIVAL_INFO') }}
      </p>
    </div>

    <div
      class="service-card-footer"
      v-if="service.route === 'prisberaknare-for-utskick'"
    >
      <p class="small">
        {{ $t('W2P_PRODUCT_DESCRIPTION_PRICE_CALCULATION') }}
      </p>
    </div>

    <div class="learn-more" v-if="service.route === 'learn-more'">
      <p class="small">
        {{ $t('W2P_SERVICE_CARD_LINK_LEARN_MORE') }}
        <pn-icon symbol="open-in-new" color="blue700" size="small" solid />
      </p>
    </div>
  </router-link>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    service: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(['isBusinessUser']),
    isDisabled() {
      return this.service.id === '8000' && !this.isBusinessUser
    }
  }
}
</script>

<style lang="scss" scoped>
.service-card {
  border: 0.1rem solid $gray200;
  cursor: pointer;
  padding: 2em 2em;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  transition: background-color 0.1s ease-in-out;
  max-width: 33rem;
  text-decoration: none;

  h2 {
    color: $gray900;
  }

  p {
    color: $gray700;
  }
}

img {
  width: 100%;
  margin: 1em 0;
}

p.service-card-description {
  margin-bottom: 1em;
}

.service-card-footer {
  margin-top: auto;
  border-top: 0.1rem solid $gray200;
  padding-top: 1em;

  .service-card-footer-text {
    display: flex;
    align-items: flex-end;

    h2,
    p {
      color: $blue700;
    }

    & > * {
      margin-right: 0.5rem;
    }
  }
}

.learn-more {
  margin-top: auto;
  p {
    color: $blue700;
    line-height: 1.2em;
    display: inline;

    pn-icon {
      margin-left: 0.25em;
    }
  }
}

.service-card:hover {
  background: $blue50;
  border-color: $blue700;
}

.service-card:active {
  background: $blue900;

  h2,
  p,
  .learn-more p {
    color: white;
  }

  .service-card-footer {
    border-top: 1px solid #fff;
  }
}

.service-card.disabled {
  border: 0.1rem solid $gray50;
  cursor: default;
  background-color: $gray50;

  img {
    opacity: 0.2;
  }

  h2,
  .small,
  .bold {
    color: $gray200;
  }

  &:active {
    .service-card-footer {
      border-top: 1px solid $gray200;
    }
  }
}
</style>
